import React, { Component } from 'react';
import './PaymentSelectionTile.scss';
import languageService from '../../../services/languageService';
import config from '../../../data/config';

class PaymentSelectionTile extends Component {
    constructor(props) {
        super(props);
        this.onPaymentSelection = props.onPaymentSelection;
        this.state = {
            paymentType: props.paymentType,
            isFocused: props.isFocused
        };
    }

    onSelection = (event) => {
        this.onPaymentSelection(this.state.paymentType.type);
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        // You don't have to do this check first, but it can help prevent an unneeded render
        if (nextProps.isFocused !== this.state.isFocused) {
            this.setState({ isFocused: nextProps.isFocused });
        }
    }

    render() {
        let paymentName = this.state.paymentType.name;
        switch(this.state.paymentType.type) {
            case 'credit-card':
                paymentName = languageService.texts.creditCard;
                break;
            case 'debit':
                paymentName = languageService.texts.debit;
                break;
            default:
        }
        return (
        <div className={"PaymentSelectionTile text-center m-2" + (this.state.isFocused ? ' active': '')}
            key={this.state.paymentType.type}
            onClick={this.onSelection}>
            <div className={`payment-logo payment-logo-${this.state.paymentType.type} mb-1 align-middle text-center`}>
                <span className="image-aligner"></span>
                <img src={config.imageUrl + this.state.paymentType.logo} alt=""/>
            </div>
            <span className="description">
                {paymentName}
            </span>
        </div>);
    }
}

export default PaymentSelectionTile;



// WEBPACK FOOTER //
// ./src/components/PaymentSelection/PaymentSelectionTile/PaymentSelectionTile.js